import React from 'react';
import { motion } from 'framer-motion';

/**
 * Bouton réutilisable avec variantes
 * variant: 'gold' | 'green' | 'outline' | 'ghost' | 'danger'
 */
function Button({
  children,
  variant = 'gold',
  size = 'md',
  fullWidth = false,
  disabled = false,
  loading = false,
  onClick,
  type = 'button',
  className = '',
  ...props
}) {
  const baseClasses = 'font-bold uppercase tracking-wider rounded-2xl transition-all duration-150 flex items-center justify-center gap-2 select-none';

  const variantClasses = {
    gold: 'bg-qfl-gold text-black hover:bg-yellow-400 disabled:opacity-50 disabled:cursor-not-allowed',
    green: 'bg-qfl-green text-white hover:bg-green-400 disabled:opacity-50 disabled:cursor-not-allowed',
    outline: 'border-2 border-qfl-gold text-qfl-gold hover:bg-qfl-gold hover:text-black disabled:opacity-50',
    ghost: 'text-white/70 hover:text-white hover:bg-white/10 disabled:opacity-50',
    danger: 'bg-qfl-red text-white hover:bg-red-400 disabled:opacity-50',
    dark: 'bg-white/10 text-white border border-white/20 hover:bg-white/20 disabled:opacity-50',
    secondary: 'bg-white/10 text-white/80 border border-white/20 hover:bg-white/20 disabled:opacity-50',
  };

  const sizeClasses = {
    sm: 'py-2 px-4 text-sm',
    md: 'py-3 px-6 text-base',
    lg: 'py-4 px-8 text-xl',
    xl: 'py-5 px-10 text-2xl',
  };

  const shadowClasses = {
    gold: 'shadow-[0_4px_20px_rgba(240,180,41,0.4)]',
    green: 'shadow-[0_4px_15px_rgba(34,197,94,0.3)]',
    outline: '',
    ghost: '',
    danger: 'shadow-[0_4px_15px_rgba(239,68,68,0.3)]',
    dark: '',
    secondary: '',
  };

  return (
    <motion.button
      type={type}
      disabled={disabled || loading}
      onClick={onClick}
      whileTap={{ scale: disabled || loading ? 1 : 0.96 }}
      className={`
        ${baseClasses}
        ${variantClasses[variant] || variantClasses.gold}
        ${sizeClasses[size]}
        ${shadowClasses[variant] || ''}
        ${fullWidth ? 'w-full' : ''}
        ${className}
      `}
      style={{ fontFamily: "'Rajdhani', sans-serif" }}
      {...props}
    >
      {loading ? (
        <>
          <span className="w-5 h-5 border-2 border-current border-t-transparent rounded-full animate-spin" />
          <span>Chargement...</span>
        </>
      ) : children}
    </motion.button>
  );
}

export default Button;
